


















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/tenugui/PopupTemplate.vue'
import QuizTenugui from '@/views/organisms/QuizTenugui.vue'

export default
  components: {
    PopupTemplate
    QuizTenugui
  }

  data: () ->
    baseColor: '#4D2095'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        'てぬぐい作りを通してCHAORAS®が'
        '目指していることは？'
      ]
      quiz: [
        '市場の活性化とみんなの笑顔'
        'デザイン性の高いてぬぐいの制作'
        'アウトドアの活発化'
      ]
      success_message: [
        '昨今、てぬぐいが次第に使われなくなり、綿産地の衰退や後継者不足が危惧されています。'
        '私たちは、てぬぐいの良さを知ってもらうためにも、実用性とデザイン性を兼ね備えた'
        'てぬぐいを届けることで市場を活性化させ、みんなの笑顔と元気を'
        '生み出したいと考えているんだよ。'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p2-18'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
